export default "__VITE_ASSET__D5rFC4Jv__"